import { krakenApi } from "../config/http-common";
import addPersonData from "../types/addPerson.type";

class OnboardingDataService {
    initChallenge(data: addPersonData) {
        return krakenApi.post<addPersonData>("/enrollment/init/otc", data);
    }
}
export default new OnboardingDataService();